// Shared YouTube relevance filters. Single source so VideoLessonTool's lesson
// search and useLearningEngine's requestBreakVideo don't drift apart.

import { supabase } from '../services/supabaseClient.js';

// Drop obvious entertainment hits whose keywords overlap with cert topics
// (the "Transformers cartoon outranks A+ power-transformer tutorial" case).
// Only blocks terms that appear ALMOST EXCLUSIVELY in entertainment — so a
// legitimate "power transformer" tutorial keeps ranking; the bare word
// "transformers" is not on the list.
export const ENTERTAINMENT_DENY = /\b(cartoon|animated\s+series|official\s+trailer|episode\s*\d|season\s*\d|music\s+video|lyric\s+video|reaction|gameplay|walkthrough|asmr|disney|marvel|netflix|prime\s+video|hbo|fan\s+edit|toy\s+review|unboxing|optimus\s+prime|hasbro|bumblebee)\b/i;

// Helper — true if either the title or channel matches the denylist.
export function isEntertainmentHit({ title = '', channel = '' }) {
  return ENTERTAINMENT_DENY.test(title) || ENTERTAINMENT_DENY.test(channel);
}

// Ask the server-side LLM re-rank pass to pick the most topically aligned
// candidate for a lesson. Resolves to the winner's YouTube ID or null
// (caller should fall back to the relevance-ordered first candidate on null).
// Single candidate? Skip the call — there's nothing to re-rank.
export async function rerankCandidates({ lessonTitle, lessonObjectives = [], trackLabel = '', candidates = [] }) {
  if (!Array.isArray(candidates) || candidates.length < 2) return null;
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    const r = await fetch('/api/yt-rerank', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body:    JSON.stringify({
        lesson_title:      lessonTitle,
        lesson_objectives: lessonObjectives,
        track_label:       trackLabel,
        candidates,
      }),
    });
    if (!r.ok) return null;
    const body = await r.json().catch(() => ({}));
    return body?.winner_id || null;
  } catch {
    return null;
  }
}
